<template>
  <div class="main-header-menu">
    <span class="main-header-menu__icon" @click.stop="toggleMenu">&#x2807;</span>
    <div
      class="main-header-menu__items"
      :class="{
        'd-none': !isOpen
      }"
    >
      <a class="main-header-menu__item" href="#" @click.stop="logout">
        {{ $t("common.logout") }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "VMainHeaderMenu",
  data: () => ({
    isOpen: false,
    closeMenuBodyListener: undefined
  }),
  mounted() {
    this.closeMenuBodyListener = () => {
      this.closeMenu();
    };
    document.body.addEventListener("click", this.closeMenuBodyListener);
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.closeMenuBodyListener);
  },
  computed: {
    ...mapGetters({
      hasAccess: "user/hasAccessToFeature"
    })
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },

    closeMenu() {
      this.isOpen = false;
    },

    logout() {
      window.msal.logout();
    }
  }
};
</script>

<style lang="scss" scoped>
.main-header-menu {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  z-index: 9;

  &__icon {
    font-size: 24px;
    position: relative;
    top: 2px;
  }

  &__items {
    position: absolute;
    right: 7px;
    top: 100%;
    background: white;
    box-shadow: 3px 10px 21px -3px rgba(0, 0, 0, 0.2);
    padding: 5px 25px;
  }

  &__item {
    padding: 7px;
    display: block;
    color: #4c4c4c;
    font-size: 13px;
    letter-spacing: 0.5px;
    font-weight: bold;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
